import type { SVGProps } from 'react';
const SvgBook1StreamlineCore = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="-0.75 -0.75 20 20" {...props}>
    <desc>{'Book 1 Streamline Icon: https://streamlinehq.com'}</desc>
    <g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5}>
      <path d="M16.518 17.84H3.964a1.982 1.982 0 1 1 0-3.965h11.232a1.32 1.32 0 0 0 1.322-1.321V1.982A1.32 1.32 0 0 0 15.196.661H3.964A1.98 1.98 0 0 0 1.982 2.59v13.214M15.196 13.875v3.964" />
    </g>
  </svg>
);
export default SvgBook1StreamlineCore;
